export class TouchPad extends Phaser.GameObjects.Container {
  constructor(scene) {
    super(scene, 0, 0);
    scene.add.existing(this);
    this.setScrollFactor(0);

    this._padBackground = scene.add.image(0, 0, 'graphics', 'joystick_bg');
    this._padStick = scene.add.image(0, 0, 'graphics', 'joystick_thumb');
    this._padDirection = { x: 0, y: 0 };
    this._maxDrag = this._padBackground.width * 0.3;
    this._padBackground.setScrollFactor(0);
    this._activePointer = null;

    // this._padBackground.on('pointermove', this._handlePointerMove, this);
    this._padBackground.setInteractive({});
    this.add([this._padBackground, this._padStick]);
  }

  enable() {
    this._padBackground.on('pointerdown', this._handlePointerDown, this);
  }

  disable() {
    this._padBackground.off('pointerdown', this._handlePointerDown, this);
  }

  get displayWidth() {
    return this._padBackground.displayWidth * this.scaleX;
  }
  get displayHeight() {
    return this._padBackground.displayHeight * this.scaleY;
  }

  setDemoDirection(x, y) {
    if (x === 0 && y === 0) {
      this._padStick.x = this._padStick.y = 0;
      return;
    }
    const angle = Phaser.Math.Angle.BetweenPoints({ x: 0, y: 0 }, { x, y });
    this._padStick.x = Math.cos(angle) * this._maxDrag;
    this._padStick.y = Math.sin(angle) * this._maxDrag;
  }

  getMovementDirection() {
    return {
      x: this._padStick.x / this._maxDrag,
      y: this._padStick.y / this._maxDrag,
    };
  }

  _handlePointerUp(e) {
    if (e === this._activePointer) {
      this._padStick.x = this._padStick.y = 0;
      this.scene.input.off('pointerup', this._handlePointerUp, this);
      this.scene.input.off('pointermove', this._handlePointerMove, this);
      this._activePointer = false;
    }
  }

  _handlePointerDown(e) {
    this._activePointer = e;
    this.scene.input.on('pointerup', this._handlePointerUp, this);
    this.scene.input.on('pointermove', this._handlePointerMove, this);
    this._handlePointerMove(e);
  }

  _handlePointerMove(e) {
    if (!this._padBackground.visible || e != this._activePointer) return;
    const x = e.worldX - this.scene.cameras.main.scrollX;
    const y = e.worldY - this.scene.cameras.main.scrollY;
    const angle = Phaser.Math.Angle.BetweenPoints(this, { x, y });
    const dist = Phaser.Math.Distance.BetweenPoints(this, { x, y });
    this._padStick.x = Math.cos(angle) * Math.min(this._maxDrag, dist);
    this._padStick.y = Math.sin(angle) * Math.min(this._maxDrag, dist);
    if (Math.abs(this._padStick.x) > Math.abs(this._padStick.y)) {
      this._padDirection.x = this._padStick.x > 0 ? 1 : -1;
      this._padDirection.y = 0;
    } else {
      this._padDirection.y = this._padStick.y > 0 ? 1 : -1;
      this._padDirection.x = 0;
    }
  }
  getDirection() {
    return this.isUse ? { ...this._padDirection } : { x: 0, y: 0 };
  }
}
